export type AuthenticateRequest = {
    email: string,
    captchaToken: string
}

export const defaultAuthenticateRequest: AuthenticateRequest = {email: "", captchaToken: ""}; 